import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import BookingModal from "@/components/BookingModal";
import { useState } from "react";
import { DIARIES } from "@/lib/diaries";
import { CameraIcon, CherrySwirl, PolaroidIcon, WaveDivider } from "@/components/Brand";

export default function DiarioList() {
  const [bookingOpen, setBookingOpen] = useState(false);
  return (
    <main className="bg-cerenza-cream text-cerenza-ink overflow-x-clip" data-testid="diario-list">
      <Nav onBook={() => setBookingOpen(true)} />

      {/* HEADER */}
      <section className="relative pt-36 pb-16 md:pt-44 md:pb-20">
        <CherrySwirl color="#cd2e2e" className="hidden md:block absolute top-32 left-[6%] w-14 h-14 opacity-50 animate-float" />
        <PolaroidIcon color="#cd2e2e" className="hidden md:block absolute top-28 right-[8%] w-14 h-14 opacity-50 animate-float" />
        <div className="max-w-[1320px] mx-auto px-6 md:px-12 text-center">
          <p className="eyebrow flex items-center justify-center gap-2">
            <CameraIcon color="#cd2e2e" className="w-5 h-5" /> Diario visual
          </p>
          <h1 className="font-display text-6xl md:text-[88px] leading-[0.95] text-cerenza-cherry mt-5 text-balance">
            Las historias que <em className="not-italic font-script text-[1.08em]">contamos</em>.
          </h1>
          <p className="mt-7 max-w-2xl mx-auto text-cerenza-ink/70 text-base md:text-lg leading-relaxed">
            Un espacio donde cada sesión se convierte en un capítulo.
            Entra al detrás de cámaras de las familias que han pasado por Cerenza.
          </p>
        </div>
      </section>

      <WaveDivider from="#ffffd7" to="#f9d4d3" />

      {/* GRID */}
      <section className="bg-cerenza-pinklight">
        <div className="max-w-[1320px] mx-auto px-6 md:px-12 py-20 md:py-28">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
            {DIARIES.map((d, i) => (
              <Link
                key={d.slug}
                to={`/diario/${d.slug}`}
                data-testid={`diary-card-${d.slug}`}
                className="group block bg-cerenza-cream rounded-[40px] overflow-hidden shadow-[0_18px_36px_-22px_rgba(220,45,63,0.35)] hover:-translate-y-2 transition-transform duration-500"
              >
                <div className={`aspect-[4/5] overflow-hidden ${d.fit === "contain" ? (d.monochrome ? "bg-cerenza-pinklight" : "bg-cerenza-cream") : ""}`}>
                  <img
                    src={d.coverImage}
                    alt={d.title}
                    className={`w-full h-full ${d.fit === "contain" ? "object-contain" : "object-cover object-top"} transition-transform duration-[1200ms] group-hover:scale-105 ${d.monochrome ? "" : "photo-warm"}`}
                  />
                </div>
                <div className="p-6 md:p-7">
                  <p className="eyebrow">Capítulo {String(i + 1).padStart(2, "0")} · {d.subtitle}</p>
                  <h3 className="font-display text-2xl md:text-3xl mt-3 text-cerenza-ink leading-tight">
                    {d.title}
                  </h3>
                  <p className="mt-3 text-sm text-cerenza-ink/65">{d.date} · {d.location}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] font-semibold text-cerenza-cherry group-hover:gap-4 transition-all">
                    Leer historia
                    <span className="block h-px w-6 bg-current transition-all duration-500 group-hover:w-10" />
                  </span>
                </div>
              </Link>
            ))}

            {/* Empty soon slot */}
            <div className="hidden md:flex flex-col items-center justify-center text-center border-2 border-dashed border-cerenza-pink rounded-[40px] aspect-[4/5] p-8 bg-cerenza-cream/50">
              <CherrySwirl color="#cd2e2e" className="w-12 h-12 opacity-60 animate-float" />
              <p className="mt-4 font-display text-2xl text-cerenza-cherry">Próximamente</p>
              <p className="mt-2 text-sm text-cerenza-ink/55">Nuevas familias, nuevas historias.</p>
            </div>
          </div>
        </div>
      </section>

      <Footer onBook={() => setBookingOpen(true)} />
      <BookingModal open={bookingOpen} onOpenChange={setBookingOpen} />
    </main>
  );
}
